import EuroIcon from '@mui/icons-material/Euro';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PublicIcon from '@mui/icons-material/Public';
import {
  Alert,
  Button as MuiButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import uniqBy from 'lodash.uniqby';
import React, { Fragment, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import { Button, Card, CardBody, CardHeader, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { AccordionElement } from 'src/component/Accordion';
import { DeleteButtonIcon } from 'src/component/Buttons/DeleteButtonIcon';
import NestedAccordion from 'src/component/LocalityAccordion';
import { GlobalModal } from 'src/component/Modal';
import ProjectForm from 'src/component/ProjectForm';
import ProjectWrapper from 'src/component/ProjectWrapper';
import { Row } from 'src/component/Table/Row';
import { useCollection } from 'src/hooks/useCollection';
import { useUser } from 'src/hooks/useUser';
import { useHttpClient } from 'src/security/hooks/axiosProvider';
import SweetAlert from 'sweetalert2';
import { useSubActivity } from '../../../../hooks/useSubActivity';
import { useDevise } from '../../setting/devise/DevisePage';
import styles from '../../styles/style-project.module.scss';
import TechnicianColumns from './table-header/technicien-columns';

const CreateProjectPage: React.FC<{ t: (key: string) => string }> = (props) => {
  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
  } = useForm();

  const { user } = useUser();

  const httpClient = useHttpClient(true);
  const history = useHistory();
  const [spinner, setSpinner] = useState(false);
  const [CreateModalUser, setCreateModalUser] = useState(false);
  const [CreateModalAdmin, setCreateModalAdmin] = useState(false);
  const { handleSubmit: handleSubmit$ } = useForm();

  const CreateModalUserToggle = () => resetUserForm();
  const CreateModalAdminToggle = () => resetAdminForm();

  const [CreateModalActivities, setCreateModalActivities] = useState(false);
  const CreateModalActivitiesToggle = () => resetActivitiesForm();
  const [users, setUsers] = useState([]);
  const [admin, setAdmin] = useState([]);

  const [selectUser, setSelectUser] = useState('');
  const [selectAdmin, setSelectAdmin] = useState('');

  const [multipleUserSelect, setMultipleUserSelect] = useState([]);
  const [selctedAdminForProject, setSelctedAdminForProject] = useState(null);

  const [collection, setCollection] = useState<any>([]);
  const { cacheCollection, collectionData } = useCollection();

  const [activityCollection, setActivityCollection] = useState([]);
  const [selectedActivityCollection, setSelectedActivityCollection] = useState([]);

  const [subActivityCollection, setSubActivityCollection] = useState([]);
  const [selectedActivities, setSelectedActivities] = useState(null);

  const [productionToggle, setProductionToggle] = useState(false);
  const [prodctionsCollection, setProdctionsCollection] = useState([]);

  const [subActivityToggle, setSubActivityToggle] = useState(false);
  const { subActivities } = useSubActivity();

  const [currentActivityId, setCurrentActivityId] = useState(null);
  const [currentSubActivityId, setCurrentSubActivityId] = useState(null);
  const [currentProductId, setCurrentProductId] = useState(null);

  const [currentCountry, setCurrentCountry] = useState(null);
  const [currentCountryError, setCurrentCountryError] = useState(null);

  // country parametres
  const [CreateCountryModal, setCreateCountryModal] = useState(false);
  const CreateCountryModalToggle = () => resetCountryForm();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countryCollection, setCountryCollection] = useState([]);

  // regions parametres
  const [ModalSelectRegions, setModalSelectRegions] = useState(false);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [regionCollection, setRegionCollection] = useState([]);
  const SelectRegionsModalToggle = () => resetRegionsForm();

  // departements parametres
  const [ModalSelectDepartements, setModalSelectDepartements] = useState(false);
  const [selectedDepartements, setSelectedDepartements] = useState([]);
  const [selectedDepartement, setSelectedDepartement] = useState(null);
  const [departementCollection, setDepartementCollection] = useState([]);
  const SelectDepartementsModalToggle = () => resetDepartementsForm();

  // communes parametres
  const [ModalSelectCommunes, setModalSelectCommunes] = useState(false);
  const [selectedCommunes, setSelectedCommunes] = useState([]);
  const [selectedCommune, setSelectedCommune] = useState(null);
  const [communeCollection, setCommuneCollection] = useState([]);
  const SelectCommunesModalToggle = () => resetCommunesForm();

  // villages parametres
  const [ModalSelectVillages, setModalSelectVillages] = useState(false);
  const [selectedVillages, setSelectedVillages] = useState([]);
  const [villageCollection, setVillageCollection] = useState([]);
  const [selectedVillage, setSelectedVillage] = useState(null);
  const SelectVillagesModalToggle = () => resetVillagesForm();

  let userDataTable = [];
  let UserData = [];
  const [activities, setActivities] = useState([]);
  const [multipleActivitiesSelect, setMultipleActivitiesSelect] = useState([]);
  let activitiesDataTable = [];
  let activitiesData = [];

  const onSubmit = async (data) => {
    if (data.project_start_date > data.project_end_date) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('startDate_greater_than_endDate'),
      });
      setSpinner(false);
      return;
    }
    if (currentDevise === null || currentDevise.name === null) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Oops...',
        text: props.t('fill_devise'),
      });
      return;
    } else if (!selctedAdminForProject) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Oops...',
        text: props.t('project.admin.error'),
      });
      return;
    }

    if (!currentCountry) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Oops...',
        text: props.t('CountryUndefined'),
      });
      return;
    }

    const projectData = {
      name: data?.project_name,
      description: data?.project_description,
      startDate: data?.project_start_date,
      endDate: data?.project_end_date,

      activityList: collection.map((item) => {
      const sub$ = item.sub_activities ?? [];

      return {
        ...item,
        subActivityList: sub$.map((subItem) => {
          const prod$ = subItem.productions ?? [];

          return {
            ...subItem,
            productionList: prod$,
          };
        }),
      };
    }),

      userList: [...UserData],
      administrator: selctedAdminForProject,
      devise: currentDevise,
      country: currentCountry,
    };

    try {
      setSpinner(true);
      await httpClient.current?.post('/api/project', projectData);
      setSpinner(false);
      SweetAlert.fire({
        icon: 'success',
        text: props.t('project_Created'),
      });
      history.push('/project/list');
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Oops...',
        text: props.t('err'),
      });
    } finally {
      resetForm();
      setSpinner(false);
    }
  };

  const onSubmitUsers = () => {
    setMultipleUserSelect(multipleUserSelect);
    multipleUserSelect.push(selectUser);
    resetUserForm();
  };
  const onSubmitAdmins = () => {
    resetAdminForm();

    if (!selectAdmin) return;
    let currentAdmin = admin.find((item) => item.username === selectAdmin);

    let administrator = {
      id: currentAdmin.id,
      username: currentAdmin.username,
      nom: currentAdmin.lastName,
      prenom: currentAdmin.firstName,
      email: currentAdmin.email,
    };

    setSelctedAdminForProject(administrator);
  };

  const deleteUser = (userName) => {
    setMultipleUserSelect(multipleUserSelect.filter((user) => user !== userName));
  };

  const deleteActivity = (activityName) => {
    setMultipleActivitiesSelect(multipleActivitiesSelect.filter((activity) => activity !== activityName));
  };

  const resetUserForm = () => {
    setSelectUser('');
    setCreateModalUser(!CreateModalUser);
  };
  const resetAdminForm = () => {
    setSelectAdmin('');
    setCreateModalAdmin(!CreateModalAdmin);
  };

  const resetSubActivitiesForm = () => {
    setCurrentSubActivityId(null);
  };
  const resetProductionForm = () => {
    setCurrentProductId(null);
  };
  const resetActivitiesForm = () => {
    setSelectedActivities(null);
    setCreateModalActivities(!CreateModalActivities);
  };

  const resetForm = async () => {
    resetField('project_name');
    resetField('project_start_date');
    resetField('project_end_date');
    resetField('project_description');
    setMultipleUserSelect([]);
    setMultipleActivitiesSelect([]);
  };
  const resetCountryForm = () => {
    setSelectedCountry(null);
    setCreateCountryModal(!CreateCountryModal);
  };

  users.map((user) => {
    multipleUserSelect.map((selectedValue) => {
      if (user.username === selectedValue) {
        UserData.push({
          id: user.id,
          username: user.username,
          nom: user.lastName,
          prenom: user.firstName,
          email: user.email,
        });
        userDataTable.push({
          name: user.username,
          nom: user.lastName,
          prenom: user.firstName,
          email: user.email,
          action: (
            <span>
              <DeleteButtonIcon
                title={props.t('delete_t')}
                onClick={() =>
                  SweetAlert.fire({
                    title: props.t('you_delete'),
                    text: props.t('not_recover'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ok',
                    cancelButtonText: props.t('cancel'),
                    reverseButtons: true,
                  }).then((result) => {
                    if (result.value) {
                      deleteUser(user.username);
                      SweetAlert.fire(props.t('Deleted!'), props.t('isDeleted'), 'success');
                    } else {
                      SweetAlert.fire(props.t('isNotDeleted'));
                    }
                  })
                }
                className={`fa fa-trash  ${styles['trash']}`}
              />
            </span>
          ),
        });
      }
      return userDataTable;
    });
    return UserData;
  });

  activities.map((activity) => {
    multipleActivitiesSelect.map((selectedValue) => {
      if (activity.name === selectedValue) {
        activitiesData.push({ id: activity.id, name: activity.name });
        activitiesDataTable.push({
          name: activity.name,
          action: (
            <span>
              <i
                onClick={() =>
                  SweetAlert.fire({
                    title: props.t('you_delete'),
                    text: props.t('not_recover'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ok',
                    cancelButtonText: props.t('cancel'),
                    reverseButtons: true,
                  }).then((result) => {
                    if (result.value) {
                      deleteActivity(activity.name);
                      SweetAlert.fire(props.t('Deleted!'), props.t('isDeleted'), 'success');
                    } else {
                      SweetAlert.fire(props.t('isNotDeleted'));
                    }
                  })
                }
                className={`fa fa-trash  ${styles['trash']}`}
              ></i>
            </span>
          ),
        });
      }
      return activitiesDataTable;
    });
    return activitiesData;
  });

  useEffect(() => {
    const getUsers = async () => {
      httpClient.current?.get(`/api/users/all`).then((response) => {
        setUsers(uniqBy(response.data, 'id'));
      });
    };
    getUsers();

    const getAdmins = async () => {
      httpClient.current?.get(`/api/users/allAdmins`).then((response) => {
        setAdmin(uniqBy(response.data, 'id'));
      });
    };
    getAdmins();

    const getActivities = async () => {
      httpClient.current?.get(`/api/activity/all`).then((response) => {
        setActivityCollection(response.data);
        setActivities(response.data);
      });
    };
    getActivities();
  }, [httpClient]);

  const handleDeleteActivity = async (id) => {
    const result = await SweetAlert.fire({
      title: props.t('you_delete'),
      text: props.t('not_recover'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: props.t('cancel'),
      reverseButtons: true,
    });

    if (result.value) {
      setCollection((prev) => {
        return prev
          .map((item) => {
            if (item.id === id) {
              item.sub_activities = [];
            }
            return item;
          })
          .filter((item) => item.id !== id);
      });

      setSelectedActivityCollection((prev) => prev.filter((item) => item !== id));

      SweetAlert.fire(props.t('Deleted!'), props.t('isDeleted'), 'success');
    } else {
      SweetAlert.fire(props.t('isNotDeleted'));
    }
  };

  const handleAddSubActivity = async (id) => {
    // open modal for add sub activity
    setSubActivityToggle(true);
    setCurrentActivityId(id);

    // // get sub activity from activity id
    const cache = subActivities
      .map((item) => {
        const is = item.activity.id === id;
        if (is) {
          return {
            activityId: item.activity.id,
            subActivityId: item.id,
            subActivityName: item.name,
          };
        }
        return null;
      })
      .filter(Boolean);

    setSubActivityCollection(uniqBy(cache, 'subActivityId'));
  };

  const onSubmitSubActivity = () => {
    const activityId = +currentActivityId;
    const subActivityId = +currentSubActivityId;

    const newCollection = collection.map((item) => {
      if (item.id === activityId) {
        if (!item.sub_activities) {
          item.sub_activities = [];
        }

        const isExist = item.sub_activities.find((sub) => sub.id === subActivityId);
        if (!isExist) {
          item.sub_activities.push({
            id: subActivityId,
            name: subActivities.find((item) => item.id === subActivityId).name,
          });
        }
      }
      delete item?.valid;
      resetSubActivitiesForm();
      return item;
    });

    setCollection(newCollection);

    setSubActivityToggle(false);
  };

  const handleDeleteSubActivity = async (activityId, subActivityId) => {
    const result = await SweetAlert.fire({
      title: props.t('you_delete'),
      text: props.t('not_recover'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: props.t('cancel'),
      reverseButtons: true,
    });

    if (result.value) {
      const newCollection = collection.map((item) => {
        if (item.id === activityId) {
          item.sub_activities = item.sub_activities.filter((item) => item.id !== subActivityId);
        }
        return item;
      });

      setCollection(newCollection);

      SweetAlert.fire(props.t('Deleted!'), props.t('isDeleted'), 'success');
    } else {
      SweetAlert.fire(props.t('isNotDeleted'));
    }
  };

  const onSubmitActivities = () => {
    const activity = activityCollection.find((activity) => +activity.id === +selectedActivities);
    setSelectedActivityCollection((prev) => [...prev, +selectedActivities]);
    setCollection([...collection, activity]);

    setMultipleActivitiesSelect(multipleActivitiesSelect);
    resetActivitiesForm();
  };

  const handleAddProductionToSubActivity = (activityId$, subActivityId$) => {
    setProductionToggle(true);
    setCurrentSubActivityId(subActivityId$);

    const collectionItem = collectionData.find((item) => item.id === +activityId$);

    if (collectionItem) {
      const subActivityItem = collectionItem.subActivities.find((item) => item.id === +subActivityId$);

      if (subActivityItem) {
        const productions = subActivityItem.productions;
        setProdctionsCollection(productions);
      } else {
        console.error(`Subactivity with id ${subActivityId$} not found.`);
      }
    } else {
      console.error(`Collection item with id ${activityId$} not found.`);
    }

  };

  const onSubmitProduction = () => {
    const productionId = +currentProductId;
    const activityId = +currentActivityId;
    const subActivityId = +currentSubActivityId;

    let production = collectionData
      .find((item) => item.id === activityId)
      .subActivities.find((item) => item.id === subActivityId)
      .productions.find((item) => item.id === productionId);

    if (!production) {
      return;
    }

    const newCollection = collection.map((item) => {
      if (item.id === activityId) {
        if (!item.sub_activities) {
          item.sub_activities = [];
        }

        const subActivity = item.sub_activities.find((sub) => sub.id === subActivityId);
        if (!subActivity.productions) {
          subActivity.productions = [];
        }

        const isExist = subActivity.productions.find((item) => item.id === productionId);
        if (!isExist) {
          subActivity.productions.push(production);
        }
      }
      return item;
    });

    setCollection(newCollection);
    resetProductionForm();
    setProductionToggle(false);
  };

  const handleDeleteProductionFromSubActivity = (productID, subActivityID) => {
    const newCollection = collection.map((item) => {
      if (!item.sub_activities) {
        item.sub_activities = [];
      }

      const subActivity = item.sub_activities.find((sub) => sub.id === +subActivityID);
      if (!subActivity.productions) {
        subActivity.productions = [];
      }

      subActivity.productions = subActivity.productions.filter((item) => item.id !== +productID);
      return item;
    });
    setCollection(newCollection);
  };

  const mappingSub =
    collection
      .map((item) => item.sub_activities)
      .flat()
      .filter(Boolean) || [];

  const mappingProduction =
    collection
      .map((item) => {
        return (item?.sub_activities || [])
          .map((sub) => sub.productions)
          .flat()
          .filter(Boolean);
      })
      .flat()
      .filter(Boolean) || [];

  const { devise } = useDevise();
  const [selectedDeviseID, setSelectedDeviseID] = useState(null);
  const [deviseToggle, setDeviseToggle] = useState(false);
  const [selectedDeviseName, setSelectedDeviseName] = useState(null);
  const [currentDevise, setCurrentDevise] = useState(null);

  const handleSubmitDevise = () => {
    const $devise = devise.find((item) => item.id === +selectedDeviseID);
    setCurrentDevise($devise);
    setSelectedDeviseName($devise.name);
    setDeviseToggle(false);
  };

  /////////////////////////////////////////////////////////
  useEffect(() => {
    const getCountryCollection = async () => {
      httpClient.current?.get(`/api/country/all`).then((response) => {
        setCountryCollection(response.data);
      });
    };
    getCountryCollection();
  }, [httpClient]);

  const onSubmitSelectCountry = () => {
    setCurrentCountry(JSON.parse(selectedCountry));
    setCreateCountryModal(false);
  };

  const resetRegionsForm = () => {
    setModalSelectRegions(!ModalSelectRegions);
    return;
  };
  const resetDepartementsForm = () => {
    setModalSelectDepartements(!ModalSelectDepartements);
    return;
  };
  const resetCommunesForm = () => {
    setModalSelectCommunes(!ModalSelectCommunes);
    return;
  };
  const resetVillagesForm = () => {
    setModalSelectVillages(!ModalSelectVillages);
    return;
  };

  useEffect(() => {
    if (!currentCountry) return;
    const getRegions = async () => {
      const response = await httpClient.current?.get('/api/region/all');
      let regions = response.data;
      regions = regions.filter((region) => region.country.id === currentCountry.id);
      regions = regions.filter((region) => !selectedRegions.find((item) => item.id === region.id));
      setRegionCollection(regions);
    };
    getRegions();
  }, [httpClient, currentCountry, selectedRegions]);
  useEffect(() => {
    if (!selectedRegion) return;
    const getDepartements = async () => {
      const response = await httpClient.current?.get('/api/departement/all');
      let departements = response.data;
      departements = departements.filter((departement) => departement.region.id === +selectedRegion);
      departements = departements.filter(
        (departement) => !selectedDepartements.find((item) => item.id === departement.id)
      );
      setDepartementCollection(departements);
    };
    getDepartements();
  }, [httpClient, selectedRegion, selectedDepartements]);
  useEffect(() => {
    if (!selectedDepartement) return;
    const getCommunes = async () => {
      const response = await httpClient.current?.get('/api/commune/all');
      let communes = response.data;
      communes = communes.filter((commune) => commune.departement.id === +selectedDepartement);
      communes = communes.filter((commune) => !selectedCommunes.find((item) => item.id === commune.id));
      setCommuneCollection(communes);
    };
    getCommunes();
  }, [httpClient, selectedDepartement, selectedCommunes]);
  useEffect(() => {
    if (!selectedCommune) return;
    const getVillages = async () => {
      const response = await httpClient.current?.get('/api/village/all');
      let villages = response.data;
      villages = villages.filter((village) => village.commune.id === +selectedCommune);
      villages = villages.filter((village) => !selectedVillages.find((item) => item.id === village.id));
      setVillageCollection(villages);
    };
    getVillages();
  }, [httpClient, selectedCommune, selectedVillages, selectedCommunes]);
  const onSubmitRegions = () => {
    const region = regionCollection.find((region) => +region.id === +selectedRegion);
    const updatedSelectedRegions = [...selectedRegions, region];
    setCurrentCountry((prevCountry) => {
      const updatedCountry = { ...prevCountry };
      updatedCountry.regionList = updatedSelectedRegions;
      return updatedCountry;
    });
    setSelectedRegions(updatedSelectedRegions);
    setRegionCollection(regionCollection.filter((item) => item.id !== +selectedRegion));
    resetRegionsForm();
  };

  const onSubmitDepartements = () => {
    const departement = departementCollection.find((departement) => +departement.id === +selectedDepartement);
    setSelectedDepartements([...selectedDepartements, departement]);
    setTimeout(() => {
      setCurrentCountry((prevCountry) => {
        const updatedCountry = { ...prevCountry };
        updatedCountry.regionList = updatedCountry.regionList.map((region) => {
          if (region.id === +selectedRegion) {
            if (!region.departementList) {
              region.departementList = [];
            }
            region.departementList.push(departement);
          }
          return region;
        });
        return updatedCountry;
      });
      setDepartementCollection(departementCollection.filter((item) => item.id !== +selectedDepartement));
      resetDepartementsForm();
    }, 100);
  };
  const onSubmitCommunes = () => {
    const commune = communeCollection.find((commune) => +commune.id === +selectedCommune);
    setSelectedCommunes([...selectedCommunes, commune]);
    setTimeout(() => {
      setCurrentCountry((prevCountry) => {
        const updatedCountry = { ...prevCountry };
        updatedCountry.regionList = updatedCountry.regionList.map((region) => {
          if (region.id === +selectedRegion) {
            region.departementList = region.departementList.map((departement) => {
              if (departement.id === +selectedDepartement) {
                if (!departement.communeList) {
                  departement.communeList = [];
                }
                departement.communeList.push(commune);
              }
              return departement;
            });
          }
          return region;
        });
        return updatedCountry;
      });
    }, 100);
    setCommuneCollection(communeCollection.filter((item) => item.id !== +selectedCommune));
    resetCommunesForm();
  };
  const onSubmitVillages = () => {
    const village = villageCollection.find((village) => +village.id === +selectedVillage);
    setTimeout(() => {
      setCurrentCountry((prevCountry) => {
        const updatedCountry = { ...prevCountry };
        updatedCountry.regionList = updatedCountry.regionList.map((region) => {
          if (region.id === +selectedRegion) {
            region.departementList = region.departementList.map((departement) => {
              if (departement.id === +selectedDepartement) {
                departement.communeList = departement.communeList.map((commune) => {
                  if (commune.id === +selectedCommune) {
                    if (!commune.villageList) {
                      commune.villageList = [];
                    }
                    commune.villageList.push(village);
                  }
                  return commune;
                });
              }
              return departement;
            });
          }
          return region;
        });
        return updatedCountry;
      });
    }, 100);
    setSelectedVillages([...selectedVillages, village]);
    setVillageCollection(villageCollection.filter((item) => item.id !== +selectedVillage));
    resetVillagesForm();
  };

  const onDelete = async (object, id) => {
    const result = await SweetAlert.fire({
      title: props.t('you_delete'),
      text: props.t('not_recover'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: props.t('cancel'),
      reverseButtons: true,
    });
    if (result.value) {
      if (object === 'region') {
        const updatedSelectedRegions = selectedRegions.filter((item) => item.id !== id);
        setSelectedRegions(updatedSelectedRegions);
        setTimeout(() => {
          setCurrentCountry((prevCountry) => {
            const updatedCountry = { ...prevCountry };
            updatedCountry.regionList = updatedSelectedRegions;
            return updatedCountry;
          });
        }, 100);
      } else if (object === 'departement') {
        const updatedSelectedDepartements = selectedDepartements.filter((item) => item.id !== id);
        setSelectedDepartements(updatedSelectedDepartements);
        setTimeout(() => {
          setCurrentCountry((prevCountry) => {
            const updatedCountry = { ...prevCountry };
            updatedCountry.regionList = updatedCountry.regionList.map((region) => {
              region.departementList = region.departementList.filter((item) => item.id !== id);
              return region;
            });
            return updatedCountry;
          });
        }, 100);
      } else if (object === 'commune') {
        const updatedSelectedCommunes = selectedCommunes.filter((item) => item.id !== id);
        setSelectedCommunes(updatedSelectedCommunes);
        setSelectedVillages((prev) => prev.filter((item) => item.commune.id !== id));
        setTimeout(() => {
          setCurrentCountry((prevCountry) => {
            const updatedCountry = { ...prevCountry };
            updatedCountry.regionList = updatedCountry.regionList.map((region) => {
              region.departementList = region.departementList.map((departement) => {
                departement.communeList = departement.communeList.filter((item) => item.id !== id);
                return departement;
              });
              return region;
            });
            return updatedCountry;
          });
        }, 100);
      }
    }
  };
  const handleAddVillage = () => {
    setModalSelectVillages(!ModalSelectVillages);
  };

  const handleDeleteVillage = (village) => {
    setSelectedVillages(selectedVillages.filter((item) => item.id !== village));
    setCurrentCountry((prevCountry) => {
      const updatedCountry = { ...prevCountry };
      updatedCountry.regionList = updatedCountry.regionList.map((region) => {
        if (region.id === +selectedRegion) {
          region.departementList = region.departementList.map((departement) => {
            if (departement.id === +selectedDepartement) {
              departement.communeList = departement.communeList.map((commune) => {
                if (commune.id === +selectedCommune) {
                  commune.villageList = commune.villageList.filter((item) => item.id !== village);
                }
                return commune;
              });
            }
            return departement;
          });
        }
        return region;
      });
      return updatedCountry;
    });
  };

  return (
    <>
      <ProjectWrapper title="create_Project" spinner={spinner}>
        <ProjectForm
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          errors={errors}
          register={register}
          action="save"
          isDisabled={false}
          onSubmitAdmins={onSubmitAdmins}
          selctedAdminForProject={selctedAdminForProject}
        >
          {/* select country */}
          {user?.isSuperAdmin && (
            <div style={{ display: 'flex', gap: 15, marginBottom: '1rem' }}>
              {currentCountry && currentCountry?.name ? (
                <Alert severity="success" style={{ textTransform: 'capitalize' }}>
                  {currentCountry?.name}
                </Alert>
              ) : (
                <Alert severity="info">{props.t('choose_country')}</Alert>
              )}
              <MuiButton
                onClick={() => setCreateCountryModal(true)}
                style={{ alignSelf: 'center' }}
                variant="outlined"
                startIcon={<PublicIcon />}
              >
                {!currentCountry ? props.t('add') : props.t('edit')}
              </MuiButton>
            </div>
          )}
          {currentCountryError && (
            <Alert severity="error" className="mb-2">
              {currentCountryError}
            </Alert>
          )}
          {/* select country */}
           {/* select admin */}
           {user?.isSuperAdmin && (
           <FormGroup key="formgroup5">
            <div style={{ display: 'flex', gap: 15 }}>
              {!selctedAdminForProject ? (
                <Alert severity="info">{props.t('add_admin')}</Alert>
              ) : (
                <Alert severity="success" style={{ textTransform: 'capitalize' }}>
                  {selctedAdminForProject.username}
                </Alert>
              )}

              <Tooltip title={props.t('add_admin_desc')}>
                <MuiButton
                  onClick={onSubmitAdmins}
                  style={{ alignSelf: 'center' }}
                  variant="outlined"
                  startIcon={<PersonAddIcon />}
                >
                  {!selctedAdminForProject ? props.t('add') : props.t('edit')}
                </MuiButton>
              </Tooltip>
            </div>
          </FormGroup>
           )}
          {/* select admin */}

          {/* devise */}
          <div style={{ display: 'flex', gap: 15, marginBottom: '1rem' }}>
            {selectedDeviseName ? (
              <Alert severity="success" style={{ textTransform: 'capitalize' }}>
                {selectedDeviseName}
              </Alert>
            ) : (
              <Alert severity="info">{props.t('choose_devise')}</Alert>
            )}
            <MuiButton
              onClick={() => setDeviseToggle(true)}
              style={{ alignSelf: 'center' }}
              variant="outlined"
              startIcon={<EuroIcon />}
            >
              {!selectedDeviseName ? props.t('add') : props.t('edit')}
            </MuiButton>
          </div>
         
          

          <Modal isOpen={deviseToggle} toggle={() => setDeviseToggle(false)} centered>
            <ModalHeader>{props.t('choose_devise')}</ModalHeader>
            <ModalBody>
              <FormGroup className="form-row">
                <select className="form-control" onChange={(e) => setSelectedDeviseID(e.target.value)}>
                  <option value="">{props.t('choose_devise')}</option>
                  {devise.map((item: any) => (
                    <option style={{ textTransform: 'capitalize' }} key={item.id} value={item.id}>
                      {item.name} ({item.code})
                    </option>
                  ))}
                </select>
              </FormGroup>
              <Button
                onClick={handleSubmitDevise}
                outline
                color="success"
                className="float-right"
                type="submit"
                disabled={!selectedDeviseID}
              >
                {props.t('save')}
              </Button>
              <Button
                style={{ marginRight: '10px' }}
                color="secondary"
                className="float-right"
                onClick={() => setDeviseToggle(false)}
              >
                {props.t('Cancel')}
              </Button>
            </ModalBody>
          </Modal>
          {/* devise */}
          {/* Accordion start */}
          <div style={{ marginBottom: '20px' }}>
            {/* technicien */}
            <AccordionElement title={props.t('technicien')}>
              <div className="col d-flex justify-content-center">
                <Card className="col-md-12">
                  <CardHeader>
                    <div className="float-right">
                      <Button outline color="success" onClick={CreateModalUserToggle}>
                        {props.t('technicien')}
                      </Button>
                    </div>
                  </CardHeader>
                  <CardBody>
                    <div style={{ overflowY: userDataTable.length > 3 ? 'auto' : 'hidden', height: '200px' }}>
                      {userDataTable.length === 0 ? (
                        <Alert variant="outlined" severity="info">
                          {props.t('no_technician')}
                        </Alert>
                      ) : (
                        <TechnicianColumns data={userDataTable} />
                      )}
                    </div>
                  </CardBody>
                </Card>
              </div>
            </AccordionElement>
            {/* technicien */}

            {/* admins */}

            {/* activities */}

            <AccordionElement title={props.t('Activities/WorkShops')}>
              <div className="col d-flex justify-content-center">
                <Card className="col-md-12">
                  <CardHeader>
                    <div className="float-right">
                      <Button outline color="success" onClick={CreateModalActivitiesToggle}>
                        {props.t('Activities/WorkShops')}
                      </Button>
                    </div>
                  </CardHeader>
                  <CardBody>
                    {collection.length === 0 && (
                      <Alert variant="outlined" severity="info">
                        {props.t('no_activity')}
                      </Alert>
                    )}

                    {collection.length > 0 && (
                      <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }}>
                          <TableHead>
                            <TableRow>
                              <TableCell />
                              <TableCell>{props.t('activity_label')}</TableCell>
                              <TableCell align="right">Action</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {collection
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .map((row) => (
                                <Row
                                  clickOnActivity={setCurrentActivityId}
                                  key={row.id}
                                  row={row}
                                  t={props.t}
                                  handleDeleteSubActivity={handleDeleteSubActivity}
                                  handleAddSubActivity={handleAddSubActivity}
                                  handleDeleteActivity={handleDeleteActivity}
                                  handleAddProductionToSubActivity={handleAddProductionToSubActivity}
                                  handleDeleteProductionFromSubActivity={handleDeleteProductionFromSubActivity}
                                />
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </CardBody>
                </Card>
              </div>
            </AccordionElement>
            {/* activities */}

            {/* locality */}
            <AccordionElement title={props.t('locality')}>
              <NestedAccordion
                country={currentCountry ? currentCountry : null}
                t={props.t}
                regions={currentCountry?.regionList}
                handleAddVillage={handleAddVillage}
                handleDeleteVillage={handleDeleteVillage}
                setModalSelectRegions={setModalSelectRegions}
                setModalSelectDepartements={setModalSelectDepartements}
                setModalSelectCommunes={setModalSelectCommunes}
                setSelectedRegion={setSelectedRegion}
                setSelectedDepartement={setSelectedDepartement}
                setSelectedCommune={setSelectedCommune}
                onDelete={onDelete}
                isPreview={false}
              />
            </AccordionElement>
            {/* locality */}

            {/* localities */}
            {/* <AccordionElement title={props.t('localities')}>
              <div className="col d-flex justify-content-center">
                <Card className="col-md-12">
                  <CardHeader>
                    <div className="float-right">
                      {!toggleAddLocalities && (
                        <Button outline color="success" onClick={CreateModalLocalitiesToggle}>
                          {props.t('localities')}
                        </Button>
                      )}
                    </div>
                  </CardHeader>
                  <CardBody>
                    <div style={{ overflowY: localitiesDataTable.length > 3 ? 'auto' : 'hidden', height: '200px' }}>
                      {localitiesDataTable.length === 0 ? (
                        <Alert variant="outlined" severity="info">
                          {props.t('no_locality')}
                        </Alert>
                      ) : (
                        <LocalityColumns data={localitiesDataTable} />
                      )}
                    </div>
                  </CardBody>
                </Card>
              </div>
            </AccordionElement> */}
            {/* localities */}
          </div>
          {/* Accordion end */}
        </ProjectForm>
      </ProjectWrapper>

      <Modal isOpen={CreateModalUser} toggle={CreateModalUserToggle} centered>
        <ModalHeader toggle={CreateModalUserToggle}>{props.t('technicien')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmitUsers)}>
              <FormGroup className="form-row">
                <select
                  name="charge_user"
                  id="charge_user"
                  className="form-control"
                  value={selectUser}
                  onChange={(e) => setSelectUser(e.target.value)}
                >
                  <option value="">{props.t('select_user')}</option>
                  {multipleUserSelect.length === 0
                    ? users.map((user, index) => (
                        <option id={user.id} key={index} value={user.username}>
                          {user.username}
                        </option>
                      ))
                    : users
                        .filter((user) => !multipleUserSelect.includes(user.username))
                        .map((user, index) => (
                          <option id={user.id} key={index} value={user.username}>
                            {user.username}
                          </option>
                        ))}
                </select>
              </FormGroup>

              <Button outline color="success" className="float-right" type="submit" disabled={!selectUser}>
                {props.t('save')}
              </Button>
              <Button className={styles['btn-cancel']} onClick={CreateModalUserToggle}>
                {props.t('cancel')}
              </Button>
            </form>
          </Fragment>
        </ModalBody>
      </Modal>
      <Modal isOpen={CreateModalAdmin} toggle={CreateModalAdminToggle} centered>
        <ModalHeader toggle={CreateModalAdminToggle}>{props.t('add_admin')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmitAdmins)}>
              <FormGroup className="form-row">
                <select
                  name="charge_user"
                  id="charge_user"
                  className="form-control"
                  value={selectAdmin}
                  onChange={(e) => setSelectAdmin(e.target.value)}
                >
                  <option value="">{props.t('select_admin')}</option>
                  {admin.map((user, index) => (
                    <option id={user.id} key={index} value={user.username}>
                      {user.username}
                    </option>
                  ))}
                </select>
              </FormGroup>

              <Button outline color="success" className="float-right" type="submit" disabled={!selectAdmin}>
                {props.t('save')}
              </Button>
              <Button className={styles['btn-cancel']} onClick={CreateModalAdminToggle}>
                {props.t('cancel')}
              </Button>
            </form>
          </Fragment>
        </ModalBody>
      </Modal>

      {/* activity model */}
      <Modal isOpen={CreateModalActivities} toggle={CreateModalActivitiesToggle} centered>
        <ModalHeader toggle={CreateModalActivitiesToggle}>{props.t('Activities/WorkShops')}</ModalHeader>
        <ModalBody>
          <form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmitActivities)}>
            <FormGroup className="form-row">
              <select
                name="charge_user"
                id="charge_user"
                className="form-control"
                onChange={(e) => setSelectedActivities(e.target.value)}
              >
                <option value="">{props.t('select_activity')}</option>
                {activityCollection
                  .filter((current) => !selectedActivityCollection.includes(current.id))
                  .map((activity, index) => (
                    <option key={index} value={activity.id}>
                      {activity.name}
                    </option>
                  ))}
              </select>
            </FormGroup>

            <Button outline color="success" className="float-right" type="submit" disabled={!selectedActivities}>
              {props.t('save')}
            </Button>
            <Button className={styles['btn-cancel']} onClick={CreateModalActivitiesToggle}>
              {props.t('cancel')}
            </Button>
          </form>
        </ModalBody>
      </Modal>
      {/* activity model */}

      {/* subactivity model */}
      <GlobalModal
        onSubmit={handleSubmit(onSubmitSubActivity)}
        isOpen={subActivityToggle}
        toggle={() => {
          setSubActivityToggle(false);
          setCurrentSubActivityId(null);
        }}
        t={props.t}
        modelHeaderName={props.t('add_sub_activity')}
        selected={currentSubActivityId}
      >
        <select
          name="charge_user"
          id="charge_user"
          className="form-control"
          onChange={(e) => setCurrentSubActivityId(e.target.value)}
        >
          <option value="">{props.t('choose_sub_activity')}</option>
          {subActivityCollection
            .filter((o1) => !mappingSub.some((o2) => o1.subActivityId === o2.id))
            .map((subActivity, index) => (
              <option key={index} value={subActivity.subActivityId}>
                {subActivity.subActivityName}
              </option>
            ))}
        </select>
      </GlobalModal>
      {/* subactivity model */}

      {/* production model */}
      <GlobalModal
        onSubmit={handleSubmit(onSubmitProduction)}
        isOpen={productionToggle}
        toggle={() => {
          setProductionToggle(false);
          setCurrentProductId(null);
        }}
        t={props.t}
        modelHeaderName={props.t('add_production')}
        selected={currentProductId}
      >
        <select
          name="charge_user"
          id="charge_user"
          className="form-control"
          onChange={(e) => setCurrentProductId(e.target.value)}
        >
          <option value="">{props.t('select_product')}</option>
          {prodctionsCollection
            .filter((o1) => !mappingProduction.some((o2) => o1.id === o2.id))
            .map((product, index) => (
              <option key={index} value={product.id}>
                {product.name}
              </option>
            ))}
        </select>
      </GlobalModal>
      {/* production model */}

      {/* country model */}
      <Modal isOpen={CreateCountryModal} toggle={CreateCountryModalToggle} centered>
        <ModalHeader toggle={CreateCountryModalToggle}>{props.t('localities/country')}</ModalHeader>
        <ModalBody>
          <form className="needs-validation" noValidate onSubmit={handleSubmit$(onSubmitSelectCountry)}>
            <FormGroup className="form-row">
              <select
                name="country"
                id="country"
                className="form-control"
                onChange={(e) => setSelectedCountry(e.target.value)}
              >
                <option value="">{props.t('select_country_name')}</option>
                {countryCollection.map((country, index) => (
                  <option key={index} value={JSON.stringify(country)}>
                    {country.name}
                  </option>
                ))}
              </select>
            </FormGroup>

            <Button outline color="success" className="float-right" type="submit" disabled={!selectedCountry}>
              {props.t('save')}
            </Button>
            <Button className={styles['btn-cancel']} onClick={CreateCountryModalToggle}>
              {props.t('cancel')}
            </Button>
          </form>
        </ModalBody>
      </Modal>
      {/* country model */}

      {/* region model */}
      <Modal isOpen={ModalSelectRegions} toggle={SelectRegionsModalToggle} centered>
        <ModalHeader toggle={SelectRegionsModalToggle}>{props.t('localities/region')}</ModalHeader>
        <ModalBody>
          <form className="needs-validation" noValidate onSubmit={handleSubmit$(onSubmitRegions)}>
            <FormGroup className="form-row">
              <select
                name="region"
                id="region"
                className="form-control"
                onChange={(e) => setSelectedRegion(e.target.value)}
              >
                <option value="">{props.t('select_region')}</option>
                {regionCollection
                  .filter((current) => !selectedRegions.includes(current.id))
                  .map((region, index) => (
                    <option key={index} value={region.id}>
                      {region.name}
                    </option>
                  ))}
              </select>
            </FormGroup>

            <Button outline color="success" className="float-right" type="submit" disabled={!selectedRegions}>
              {props.t('save')}
            </Button>
            <Button className="" onClick={SelectRegionsModalToggle}>
              {props.t('cancel')}
            </Button>
          </form>
        </ModalBody>
      </Modal>
      {/* region model */}

      {/* departement model */}
      <Modal isOpen={ModalSelectDepartements} toggle={SelectDepartementsModalToggle} centered>
        <ModalHeader toggle={SelectDepartementsModalToggle}>{props.t('localities/departement')}</ModalHeader>
        <ModalBody>
          <form className="needs-validation" noValidate onSubmit={handleSubmit$(onSubmitDepartements)}>
            <FormGroup className="form-row">
              <select
                name="departement"
                id="departement"
                className="form-control"
                onChange={(e) => setSelectedDepartement(e.target.value)}
              >
                <option value="">{props.t('select_departement')}</option>
                {departementCollection
                  .filter((current) => !selectedDepartements.includes(current.id))
                  .map((departement, index) => (
                    <option key={index} value={departement.id}>
                      {departement.name}
                    </option>
                  ))}
              </select>
            </FormGroup>

            <Button outline color="success" className="float-right" type="submit" disabled={!selectedDepartements}>
              {props.t('save')}
            </Button>
            <Button className="" onClick={SelectDepartementsModalToggle}>
              {props.t('cancel')}
            </Button>
          </form>
        </ModalBody>
      </Modal>
      {/* departement model */}

      {/* commune model */}
      <Modal isOpen={ModalSelectCommunes} toggle={SelectCommunesModalToggle} centered>
        <ModalHeader toggle={SelectCommunesModalToggle}>{props.t('localities/commune')}</ModalHeader>
        <ModalBody>
          <form className="needs-validation" noValidate onSubmit={handleSubmit$(onSubmitCommunes)}>
            <FormGroup className="form-row">
              <select
                name="commune"
                id="commune"
                className="form-control"
                onChange={(e) => setSelectedCommune(e.target.value)}
              >
                <option value="">{props.t('select_commune')}</option>
                {communeCollection
                  .filter((current) => !selectedCommunes.includes(current.id))
                  .map((commune, index) => (
                    <option key={index} value={commune.id}>
                      {commune.name}
                    </option>
                  ))}
              </select>
            </FormGroup>

            <Button outline color="success" className="float-right" type="submit" disabled={!selectedCommunes}>
              {props.t('save')}
            </Button>
            <Button className="" onClick={SelectCommunesModalToggle}>
              {props.t('cancel')}
            </Button>
          </form>
        </ModalBody>
      </Modal>
      {/* commune model */}

      {/* village model */}
      <Modal isOpen={ModalSelectVillages} toggle={SelectVillagesModalToggle} centered>
        <ModalHeader toggle={SelectVillagesModalToggle}>{props.t('localities/village')}</ModalHeader>
        <ModalBody>
          <form className="needs-validation" noValidate onSubmit={handleSubmit$(onSubmitVillages)}>
            <FormGroup className="form-row">
              <select
                name="village"
                id="village"
                className="form-control"
                onChange={(e) => setSelectedVillage(e.target.value)}
              >
                <option value="">{props.t('select_village')}</option>
                {villageCollection
                  .filter((current) => !selectedVillages.includes(current.id))
                  .map((village, index) => (
                    <option key={index} value={village.id}>
                      {village.name}
                    </option>
                  ))}
              </select>
            </FormGroup>

            <Button outline color="success" className="float-right" type="submit" disabled={!selectedVillages}>
              {props.t('save')}
            </Button>
            <Button className="" onClick={SelectVillagesModalToggle}>
              {props.t('cancel')}
            </Button>
          </form>
        </ModalBody>
      </Modal>
      {/* village model */}
    </>
  );
};
export default translate(CreateProjectPage);
